/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class AccountApi {
    static getInstance() {
        if (!this.instance) this.instance = new AccountApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 激活用户账号
    async activeAccount (param){
        let url = `/api/sys/users/${param.id}/send-reg-email`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 账号列表
    async getAccountList (param, page_num, page_size){
        let url = `/api/sys/account/auth/record/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 创建账号
    async createAccount (param){
        let url = `/api/sys/account/add/backend`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 激活账号
    async activeAccount (id, user_id){
        let url = `/api/sys/account/${id}/${user_id}/active`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 禁用账号
    async disableAccount (id){
        let url = `/api/sys/account/${id}/disable`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 检查账号是否注册
    async checkAccount (param){
        let url = `/api/sys/account/auth/record/check/user`
        let result = await this.getData(url,param,'GET')
        return result
    }
    // 邀请注册账号

    async invitateRegistrateAccount (param){
        let url = `/api/sys/account/invite/register`
        let result = await this.getData(url,param,'POST')
        return result
    }
    // 语言列表

    async getLangList (){
        let url = `/api/sys/account/lang/list`
        let result = await this.getData(url,{},'GET')
        return result
    }

    

}

export {
    AccountApi
}